<div class="checkride-item-container">
    <div dwRow>
        <div dwCol="4">
            <div dwRow>
                <div dwCol="12">
                    <label class="label">Student</label>
                    <div class="read-only">
                        {{checkRideRef.applicantSelection?.ApplicantName}}
                    </div>
                </div>
            </div>
            <div dwRow>
                <div dwCol="12">
                    <label class="label">Examiner</label>
                    <div class="read-only">
                        {{checkRideRef.examinerSlotSelection.searchResult.UserIdDisplay}}
                    </div>
                </div>
            </div>
            <div dwRow>
                <div dwCol="12">
                    <label class="label">Checkride Date Time</label>
                    <div class="read-only">
                        <app-date-time-display-control [dateTime]="checkRideRef.checkride.ScheduledDateTime"
                            [airportInfo]="checkRideRef.airportInfo"></app-date-time-display-control>
                    </div>
                </div>
            </div>
        </div>
        <div dwCol="4">
            <div dwRow>
                <div dwCol="12">
                    <label class="label">Checkride Airport</label>
                    <div class="read-only">
                        {{checkRideRef.examinerSlotSelection?.searchResult.LocationDistancesAirportIdDisplay}}
                    </div>
                </div>
            </div>
            <div dwRow>
                <div dwCol="12">
                    <label class="label">Checkride Cost</label>
                    <div class="read-only">
                        {{checkRideRef.checkride.ScheduledCheckRideCost || 0 | currency}}
                    </div>
                </div>
            </div>
            <div dwRow>
                <div dwCol="12">
                    <label class="label">Examiner Booking Cost</label>
                    <div class="read-only">
                        {{checkRideRef.checkride.ExaminerBookingCost || 0 | currency}}
                    </div>
                </div>
            </div>
        </div>
        <div dwCol="4">
            <div dwRow *ngIf="checkRideRef.checkRideStatusDisplay && !checkRideRef.validationResult?.HasActiveCheckride">
                <div dwCol="12">
                    <label class="label">Status</label>
                    <div class="read-only">
                        {{ checkRideRef.checkRideStatusDisplay }}
                    </div>
                </div>
            </div>
             <div dwRow *ngIf="!checkRideRef.validationResult">
                <div dwCol="12">
                      <dw-loading [show]="!checkRideRef.validationResult" text="Validating..."></dw-loading>
                </div>
            </div>  
            <div dwRow *ngIf="checkRideRef.validationResult?.HasActiveCheckride">
                <div dwCol="12">
                    <span title="Student already has a Checkride booked for the Grade and Category."><i class="fa fa-exclamation-triangle fa-2x dw-orange"> {{checkRideRef.validationResult.Message || 'Checkride already exists' }}</i></span>

                    <div *ngFor="let checkrideDetail of checkRideRef.validationResult.ActiveCheckrideDetails">
                        {{checkrideDetail}}
                    </div>
                </div>
            </div>  
            <div dwRow>
                <div dwCol="12">
                    <dw-loading [show]="checkRideRef.savingInfo?.isSaving" text="Saving..."></dw-loading>

                    <span *ngIf="checkRideRef.savingInfo?.isSaveComplete && !checkRideRef.savingInfo?.isSaveError"><i class="fa fa-check-circle fa-2x dw-green"
                            title="Save Succussful"></i> Saved</span>
                    <span *ngIf="checkRideRef.savingInfo?.isSaveError"><i class="fa fa-ban fa-2x dw-red"
                            [title]="checkRideRef.savingInfo?.errorMessage"> Failed</i></span>

                    {{checkRideRef.savingInfo?.errorMessage}}
                </div>
            </div>
            <div dwRow *ngIf="checkRideRef.savingInfo?.isSaveComplete">
                <div dwCol="12">
                    <br><br>
                    <button class="btn btn-primary" (click)="editCheckride()">
                            <i class="fa fa-edit"></i> Edit Checkride
                        </button>
                </div>
            </div>
        </div>
    </div>
</div>
